var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"layout-footer footer",class:_vm.getLayoutFooterBg()},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid container-p-x pb-3"},[_c('a',{staticClass:"footer-link pt-3",attrs:{"href":"#"}},[_vm._v("Link 1")]),_c('a',{staticClass:"footer-link pt-3 ml-4",attrs:{"href":"#"}},[_vm._v("Link 2")])])
}]

export { render, staticRenderFns }